import DemoWallets from './DemoWallets';

export default DemoWallets;
